import React from 'react';
import PropTypes from 'prop-types';

function filterActiveCategories(categories) {
  return categories.filter(category => category.selected === true);
}

function mapTiersToArray(tiers) {
  let result = [];

  for (const property in tiers) {
    if (Object.prototype.hasOwnProperty.call(tiers, property)) {
      result = [
        ...result,
        {
          items: tiers[property],
          industry: property,
          selected: false,
        },
      ];
    }
  }

  return result;
}

class PricingTiers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: this.props.teamMarket,
    };

    this.setSelectedCategory = this.setSelectedCategory.bind(this);
    this.mapSelectedState = this.mapSelectedState.bind(this);
  }

  setSelectedCategory(selected) {
    this.setState({ selected });
  }

  mapSelectedState(category, index) {
    if (index === 0 && this.state.selected === null) {
      return { ...category, selected: true };
    }

    if (this.state.selected === category.industry) {
      return { ...category, selected: true };
    }

    return { ...category, selected: false };
  }

  render() {
    const categories = mapTiersToArray(this.props.pricing)
      .map((tier, index) => this.mapSelectedState(tier, index));

    const options = categories.map(category => (
      <button type="button" className={`radio-list__option ${category.selected ? 'is-active' : ''}`} onClick={() => this.setSelectedCategory(category.industry)} key={category.industry}>
        {category.industry}
      </button>
    ));

    const tiers = filterActiveCategories(categories)
      .reduce((acc, curr) => ([
        ...acc,
        ...curr.items,
      ]), [])
      .map((tier, index) => {
        let rangeText = '';
        let min = tier.min ? tier.min : 0;
        let max = tier.max ? tier.max : 0;
        if (tier.field === 'Revenue') {
          min = '$' + min + 'm';
          max = '$' + max + 'm';
        }
        switch (tier.type) {
          case 'bottom':
            rangeText = min + ' - ' + max;
            break;
          case 'top':
            rangeText = min + '+';
            break;
          case 'equal':
            rangeText = min;
            break;
          default:
            rangeText = min + ' - ' + max;
        }

        return <div className="l-value-list__item value-card" key={index}>
          <div className="value-card__label">{tier.field}</div>
          <div className="value-card__range">{rangeText}</div>
          <div className="value-card__divider"/>
          <div className="value-card__value">${tier.price}</div>
        </div>
      });

    return (
      <section className="l-dv__pricing">
        <header className="l-dv__pricing-title">
          <h3 className="t-dv-pricing-header">Low cost-per-lead, aligned to the size of opportunity</h3>
        </header>

        <div className="l-dv__pricing-options-wrapper">
          <div className="l-dv__pricing-options">
            <div className="radio-list">
              {options}
            </div>
          </div>
        </div>

        <div className="l-dv__pricing-values">
          <div className="l-value-list__wrapper">
            <div className="l-value-list">
              {tiers}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

PricingTiers.propTypes = {
  pricing: PropTypes.object,
  teamMarket: PropTypes.string,
};

PricingTiers.defaultProps = {
  pricing: {},
  teamMarket: null,
};

export default PricingTiers;
